import React, { PureComponent } from "react";
import * as queryString from "query-string";
import { RouteComponentProps } from "react-router-dom";
import { LoadingSpinner, PageAlert } from "@xapp/components";

export interface AcceptInviteProps extends RouteComponentProps<{}> {
    isAcceptingInvite: boolean;
    acceptInviteError?: Error;
    acceptInvite(inviteId: string): void;
}

interface QueryParams {
    inviteId?: string;
}

function getQueryParams(props: RouteComponentProps<{}>): QueryParams {
    const query = props.location.search || "";
    return queryString.parse(query);
}

export class AcceptInvite extends PureComponent<AcceptInviteProps, {}> {
    componentDidMount() {
        const query = getQueryParams(this.props);

        if (query.inviteId) {
            this.props.acceptInvite(query.inviteId);
        }
    }

    render() {
        const query = getQueryParams(this.props);
        const { isAcceptingInvite, acceptInviteError } = this.props;

        if (acceptInviteError) {
            return (
                <PageAlert background="red">
                    <h2>Error Accepting Invite</h2>
                    <p>{acceptInviteError.message}</p>
                </PageAlert>
            );
        }
        if (isAcceptingInvite) {
            return <LoadingSpinner />;
        }
        if (!query.inviteId) {
            return (
                <PageAlert background="red">
                    <h2>No Invitation To Accept</h2>
                </PageAlert>
            );
        }
        return <div />;
    }
}
